var $  = require('jquery');
var qs = require('qs');
var Cookies = require('js-cookie');
let winW = window.innerWidth;
var html_fontSize = 30; // (40 *winW)/ 1920;
var Base = {
    BaseUrl:'/stemapi/',
    webUrl:'/stemapi/web/',
    commonUrl:'/stemapi/common/'
};
var Utils = {
    getUuid: function() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;
    },
    getFileExt:function (str) {
        var index=str.lastIndexOf('.');
        return str.substring(index).toLowerCase();
    }
}
function getQueryObject(url) {
    url = url == null ? window.location.href : url;
    var search = url.substring(url.lastIndexOf("?") + 1);
    var obj = {};
    var reg = /([^?&=]+)=([^?&=]*)/g;
    search.replace(reg, function (rs, $1, $2) {
        var name = decodeURIComponent($1);
        var val = decodeURIComponent($2);
        val = String(val);
        obj[name] = val;
        return rs;
    });
    return obj;
}
var JAjax = {
    postJson: function(url, obj, success, error, finish, befor){
        $.ajax({
            contentType:'application/json;charset=utf-8',
            type:'POST',
            dataType:'json',
            data:JSON.stringify(obj),
            url:url,
            cache:false,
            success: function(resp){
               /* if(resp.code==10001){
                    Cookies.remove('stem_ooowin_token');
                    Cookies.remove('stem_ooowin_mark');
                    window.location.href='./login.html';
                    return false
                }*/
                typeof (success) == 'function' && success(resp);
            },
            error: function(){
                typeof (error) == 'function' && error();
            },
            beforeSend: function(req){
                if(Cookies.get('stem_ooowin_token')&&Cookies.get('stem_ooowin_mark')&&Cookies.get('stem_ooowin_mark')!='undefined'){
                    req.setRequestHeader("token",Cookies.get('stem_ooowin_token')||'');
                    req.setRequestHeader("mark", Cookies.get('stem_ooowin_mark')||'');
                }
                typeof (befor) == 'function' && befor();
            },
            complete: function(){
                typeof (finish) == 'function' && finish();
            }
        });
    },
    getJson:function(url, obj, success, error,finish, befor){
        $.ajax({
            contentType:'application/json;charset=utf-8',
            type:'GET',
            dataType:'json',
            data: qs.stringify(obj),
            url:url,
            cache:false,
            success: function(resp){
                if(resp.code==10001){
                    // 建党100年临时修改
                    // Cookies.remove('stem_ooowin_token');
                    // Cookies.remove('stem_ooowin_mark');
                    // setTimeout(function () {                     
                    //     window.location.href='./index.html';
                    //    // window.location.reload();
                    // },500);
                    return false
                }
                typeof (success) == 'function' && success(resp);
            },
            error: function(){
                typeof (error) == 'function' && error();
            },
            beforeSend: function(req){
                if(Cookies.get('stem_ooowin_token')&&Cookies.get('stem_ooowin_mark')&&Cookies.get('stem_ooowin_mark')!='undefined'){
                    req.setRequestHeader("token",Cookies.get('stem_ooowin_token')||'');
                    req.setRequestHeader("mark", Cookies.get('stem_ooowin_mark')||'');
                }
                typeof (befor) == 'function' && befor();
            },
            complete: function(){
                typeof (finish) == 'function' && finish();
            }
        });
    },
    deleteJson:function(url, obj, success, error,finish, befor){
        $.ajax({
            contentType:'application/json;charset=utf-8',
            type:'delete',
            dataType:'json',
            data: qs.stringify(obj),
            url:url,
            cache:false,
            success: function(resp){
                if(resp.code==10001){
                    // 建党100年修改
                    // Cookies.remove('stem_ooowin_token');
                    // Cookies.remove('stem_ooowin_mark');
                    // setTimeout(function () {
                    //     window.location.href='./index.html';
                    // },500);
                    return false
                }
                typeof (success) == 'function' && success(resp);
            },
            error: function(){
                typeof (error) == 'function' && error();
            },
            beforeSend: function(req){
                if(Cookies.get('stem_ooowin_token')&&Cookies.get('stem_ooowin_mark')&&Cookies.get('stem_ooowin_mark')!='undefined'){
                    req.setRequestHeader("token",Cookies.get('stem_ooowin_token')||'');
                    req.setRequestHeader("mark", Cookies.get('stem_ooowin_mark')||'');
                }
                typeof (befor) == 'function' && befor();
            },
            complete: function(){
                typeof (finish) == 'function' && finish();
            }
        });
    },
    postForm:function(url, obj, success, error, finish, befor){
        $.ajax({
            type:'POST',
            data:obj,
            url:url,
            cache:false,
            success: function(resp){
                if(resp.code==10001){
                    // 建党100年修改
                    // Cookies.remove('stem_ooowin_token');
                    // Cookies.remove('stem_ooowin_mark');
                    // setTimeout(function () {
                    //     window.location.href='./index.html';
                    //   //  window.location.reload();
                    // },500);
                    return false
                }
                typeof (success) == 'function' && success(resp);
            },
            error: function(){
                typeof (error) == 'function' && error();
            },
            beforeSend: function(req){
                if(Cookies.get('stem_ooowin_token')&&Cookies.get('stem_ooowin_mark')&&Cookies.get('stem_ooowin_mark')!='undefined'){
                    req.setRequestHeader("token",Cookies.get('stem_ooowin_token')||'');
                    req.setRequestHeader("mark", Cookies.get('stem_ooowin_mark')||'');
                }
                typeof (befor) == 'function' && befor();
            },
            complete: function(){
                typeof (finish) == 'function' && finish();
            }
        });
    }
};

//根据七牛图片生成图片缩略图 h=200px w=180px
//裁剪正中部分，等比缩小生成200x200缩略图：
function getThumbnail(url,w=100,h=100){
    return url+"?imageView2/1/w/"+w+"/h/"+h;
}
function changeSize(){
    winW = window.innerWidth;
    html_fontSize = 30; // (40 *winW)/ 1920;
    //document.getElementsByTagName('html')[0].style = 'font-size:'+html_fontSize+'px';
}
window.onresize = window.onload = changeSize;
export{
    getQueryObject,JAjax,$,Base,Cookies,html_fontSize,changeSize,getThumbnail,Utils
};

